/**
 * Input Schema of CargaSaraiva
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CargaSaraiva} from '@/model/resource/CargaSaraiva'

/* TODO: review generated schema */
export class InputCargaSaraivaSchema extends Schema {
  readonly name = 'InputCargaSaraiva'

  readonly fieldSet: FieldSet<CargaSaraiva> = {
    dataCriacao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    danfe: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 512,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    notaFiscal: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 256,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    nomeDestinatario: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 256,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    documentoDestinatario: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 256,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    enderecoDestinatario: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 256,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    nomeTransportador: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 256,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
